import React from 'react';
import { Container } from 'react-bootstrap';
import { site } from '../data/site';
import { analyticsEnabled } from '../analytics';

const Privacy: React.FC = () => (
  <Container className="py-5">
    <h1 className="mb-4">Privacy Policy</h1>

    <p>
      Art on the Lake ("we", "us", or "our") respects your privacy. This site is a static
      informational website for a non-profit arts organization in Pleasant Hill, Iowa.
    </p>

    <h3 className="h5 mt-4">1. Information We Collect</h3>
    <p>
      This website does not have accounts, forms, or a shopping cart, and does not ask you for
      personal information. If you email or call us using the details on this site, we receive
      whatever you choose to send us.
    </p>

    <h3 className="h5 mt-4">2. How We Use Your Information</h3>
    <p>
      We use anything you send us only to reply to you and to run the organization's programs. We do
      not sell your personal information.
    </p>

    <h3 className="h5 mt-4">3. Cookies and Analytics</h3>
    {analyticsEnabled ? (
      <>
        <p>
          We use Google Analytics to understand how visitors find and use this site — which pages
          are viewed, roughly where visitors are located, and what kind of device they use. Google
          Analytics sets cookies to do this and does not tell us who you are.
        </p>
        <p>
          We do not use this site for advertising, and we do not sell or share the data with anyone.
          If you would rather not be counted, Google publishes a{' '}
          <a
            href="https://tools.google.com/dlpage/gaoptout"
            target="_blank"
            rel="noopener noreferrer"
          >
            browser opt-out add-on
          </a>
          , and most browsers offer a "do not track" or cookie-blocking setting.
        </p>
      </>
    ) : (
      <p>
        This site does not use web analytics and does not set advertising cookies. If that changes,
        this page will be updated to say so.
      </p>
    )}

    <h3 className="h5 mt-4">4. Links to Other Sites</h3>
    <p>
      We link to sponsors, partners, and social media. Those sites have their own privacy practices,
      which we do not control.
    </p>

    <h3 className="h5 mt-4">5. Contact Us</h3>
    <p>
      Questions about this policy? Email <a href={`mailto:${site.email}`}>{site.email}</a> or call{' '}
      <a href={site.phoneHref}>{site.phone}</a>.
    </p>
  </Container>
);

export default Privacy;
